import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { IOnboardingViewData } from '../../reward-tokens.model';

@Component({
    selector: 'bs-reward-tokens-onboarding',
    templateUrl: './reward-tokens-onboarding.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    styleUrls: ['./reward-tokens-onboarding.component.scss'],
})
export class RewardTokensOnboardingComponent {
    @HostBinding('class') class = 'reward-tokens-onboarding reward-tokens-module';
    @Input() viewState: IOnboardingViewData;
    @Output() dismiss = new EventEmitter<void>();
    readonly newBadge: string;

    constructor(private sitecore: Sitecore) {
        this.newBadge = this.sitecore.quickBetHelp.NewBadge;
    }

    hideOnboarding(event: Event): void {
        event.stopPropagation();
        event.preventDefault();

        this.dismiss.emit();
    }
}
